'use client';

import Image from 'next/image';
import ReactPlayer from 'react-player';
import { useState } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import * as React from 'react';

import { ICardMedia } from '@/src/utils/collections/cards.mapper';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@/src/components/ui/dialog';

type IProps = {
  media: Extract<ICardMedia, { type: 'video' }>;
};

export const CardVideoItemPlayer = ({ media }: IProps) => {
  const [play, setPlay] = useState(false);

  return (
    <Dialog onOpenChange={open => setPlay(open)}>
      <DialogTrigger
        className={'group relative h-[260px] max-h-full w-[375px] max-w-full'}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 stroke-white transition group-hover:stroke-primary"
        >
          <circle cx="12" cy="12" r="10" />
          <polygon points="10 8 16 12 10 16 10 8" />
        </svg>
        {media.data.image && (
          <div>
            <Image
              placeholder={'blur'}
              blurDataURL={'/static/images/placeholder.webp'}
              src={media.data.image.image}
              alt={media.data.image.alt || ''}
              fill
              className="rounded-xl"
            />
          </div>
        )}
      </DialogTrigger>
      <DialogContent
        className={'h-[200px] w-[300px] px-4 lg:h-[340px] lg:w-[720px]'}
      >
        <DialogPrimitive.Close className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
          <Cross2Icon className="size-4" />
          <span className="sr-only">Close</span>
        </DialogPrimitive.Close>
        <div className={'relative h-auto w-full'}>
          <ReactPlayer
            width="auto"
            height="auto"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            playing={play}
            url={media.data.url}
            controls
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
